export const strings = {
  id: {
    "beta.label": "Beta pengujian",
    "beta.notice": "Ringkasan masih berupa simulasi, bukan hasil model AI. Lembar disimpan di perangkat. Pembayaran dan email berkala belum tersedia.",
    "beta.deleteUnavailable": "Penghapusan mandiri belum tersedia pada beta ini. Hubungi halo@axoris.id untuk permintaan penghapusan akun.",
    "auth.session.failed": "Status akun belum dapat diperiksa. Coba lagi untuk melanjutkan.",
    "intake.resume": "Lengkapi keputusan",
    "policy.page.title": "Kebijakan privasi dan ketentuan",
    "policy.page.dates": "Berlaku 6 Oktober 2026. Naskah diperbarui 11 Oktober 2026.",
    "policy.page.privacy": "Kebijakan privasi",
    "policy.page.terms": "Ketentuan penggunaan",
    "policy.page.processing": "Ringkasan pemrosesan data",
    "policy.page.account": "Akun dibuat saat Anda mendaftar. Persetujuan pemrosesan data akun diperlukan untuk menggunakan ruang kerja AXORIS.",
    "policy.page.consent": "Pemrosesan AI dan analitik memiliki persetujuan terpisah. Keduanya nonaktif secara bawaan. Saat persetujuan AI nonaktif, model tidak dipanggil.",
    "policy.page.stored": "Data yang disimpan mencakup informasi akun, foto profil jika diunggah, keputusan beserta item, opsi dan ringkasannya, lembar, sorotan, penanda, progres membaca, serta persetujuan Anda.",
    "policy.page.export": "Ekspor JSON dari halaman Akun memuat keputusan beserta item, opsi, tindak lanjut, tanggal, riwayat ringkasan dan checklist pemicu, sorotan, serta persetujuan. Ekspor tidak menyertakan analitik atau isi bab buku.",
    "policy.page.delete": "Penghapusan akun memerlukan konfirmasi dengan mengetik HAPUS, persis seperti itu, di halaman Akun. Setelah penghapusan berhasil, akun, data ruang kerja dan foto profil dihapus permanen.",
    "policy.page.access": "Akun publik mendapat uji coba tujuh hari sejak akun dibuat. Akun Pilot memiliki akses tanpa batas waktu. Pembayaran belum tersedia; saat ini tidak ada tanggal tagihan atau penagihan otomatis.",
    "policy.page.decision": "AXORIS menyusun rekomendasi. Anda memilih opsi dan mencatat alasan keputusan Anda. Pilihan yang berbeda dari rekomendasi tetap dicatat secara netral.",
    "policy.page.library": "Pustaka berisi bacaan AXORIS yang tersedia sesuai hak akses akun. Buku dibaca di AXORIS; unduhan buku tidak tersedia. Catatan tetap tersimpan saat akses membaca berakhir.",
    "policy.page.price": "Memilih periode bulanan atau tahunan dan melihat harga belum mengaktifkan langganan atau memulai penagihan.",
    "policy.page.providers": "AXORIS menggunakan Firebase untuk layanan akun dan data, serta Cloudflare untuk melayani situs. Email berkala aplikasi belum diaktifkan.",
    "policy.page.payment": "Integrasi pembayaran belum berjalan. Ringkasan ini akan diperbarui ketika layanan atau pemrosesan data berubah.",

    "language.id": "Bahasa Indonesia",
    "language.en": "Bahasa Inggris",
    "epistemic.KNOWN": "Diketahui",
    "epistemic.ASSUMED": "Diasumsikan",
    "epistemic.UNKNOWN": "Belum diketahui",
    "continuity.HOLDS": "Tetap berlaku",
    "continuity.ADJUST": "Perlu penyesuaian",
    "continuity.REVIEW": "Perlu ditinjau",
    "acc.accountPublic": "Akun publik",
    "landing.language": "Bahasa halaman",
    "workspace.back": "Kembali ke Keputusan",
    "commit.back": "Kembali ke ringkasan keputusan",
    "commit.placeholder": "Tuliskan pertimbangan utama di balik pilihan Anda.",
    "workspace.briefVersion": "Ringkasan keputusan · v{n}",
    "workspace.recordTitle": "Pilihan & alasan keputusan",
    "workspace.recordHint": "Pilih opsi dan tulis alasan Anda saat mencatat keputusan.",
    "workspace.briefEmpty": "Ringkasan keputusan belum disusun.",
    "chooseBy.label": "Harus dipilih",
    "chooseBy.empty": "Tidak ada batas pilih",
    "chooseBy.wib": "Tanggal pilihan mengikuti WIB.",
    "chooseBy.save": "Simpan tanggal",
    "chooseBy.saved": "Tanggal pilihan disimpan.",
    "chooseBy.error": "Tanggal pilihan belum tersimpan. Coba lagi.",
    "trigger.occurred": "Pemicu terjadi",
    "trigger.error": "Centang belum tersimpan. Coba lagi.",
    "att.unselected": "belum dipilih",
    "app.name": "AXORIS",
    "skip": "Lewati ke konten",
    "nav.main": "Navigasi utama",
    "nav.attention": "Perhatian",
    "nav.decisions": "Keputusan",
    "nav.library": "Pustaka",
    "nav.account": "Akun",
    "nav.collapse": "Ciutkan panel navigasi",
    "nav.expand": "Lebarkan panel navigasi",
    "decision.new": "Keputusan baru",
    "attention.empty": "Tidak ada yang menuntut perhatian. Ini keadaan yang baik.",
    "attention.lede": "Keputusan yang Anda tandai dan yang perlu ditindaklanjuti, dalam satu antrean.",
    "attention.active": "Keputusan: {count}",
    "attention.quiet": "Tidak ada antrean",
    "attention.queue": "Perlu diperhatikan ({count})",
    "attention.nextAction": "Langkah berikutnya",
    "attention.pinned": "Ditandai",
    "attention.reviewCta": "Buka keputusan",
    "attention.quietBody": "Saat ini tidak ada keputusan yang perlu ditampilkan di Perhatian. Anda dapat membuka daftar Keputusan atau membuat keputusan baru.",
    "attention.todaySheet": "Lembar hari ini",
    "error.read": "Tidak dapat memuat. Coba lagi.",
    "retry": "Coba lagi",
    "field.name": "Nama tampilan",
    "field.email": "Email",
    "field.password": "Kata sandi",
    "auth.or": "atau",
    "auth.google": "Masuk dengan Google",
    "auth.login.title": "Masuk",
    "auth.login.lede": "Akses ruang kerja keputusan Anda.",
    "auth.login.stitchLede": "Akses ruang kerja keputusan eksekutif Anda.",
    "auth.login.stitchLedeDesktop": "Masuk ke ruang kerja keputusan eksekutif.",
    "auth.login.googleDivider": "atau masuk dengan",
    "auth.login.googleDesktop": "Masuk dengan Google",
    "auth.login.registerDesktop": "Daftar",
    "auth.login.access": "Akses akun",
    "auth.login.back": "Kembali ke AXORIS",
    "auth.login.forgotLink": "Lupa kata sandi?",
    "auth.login.registerPrompt": "Belum memiliki akun?",
    "auth.login.registerLink": "Buat akun",
    "auth.login.help": "Bantuan:",
    "auth.login.policy": "Kebijakan & ketentuan",
    "auth.login.emailPlaceholder": "nama@perusahaan.com",
    "auth.login.failed": "Belum bisa masuk. Periksa email dan kata sandi, lalu coba lagi.",
    "auth.login.unavailable": "Proses masuk belum selesai. Coba lagi setelah koneksi atau layanan tersedia.",
    "auth.google.failed": "Belum bisa masuk dengan Google. Coba lagi.",
    "auth.showPw": "Tampilkan kata sandi",
    "auth.hidePw": "Sembunyikan kata sandi",
    "auth.login.submit": "Masuk",
    "auth.login.busy": "Masuk...",
    "auth.forgot": "Lupa kata sandi",
    "auth.forgot.sent": "Periksa kotak masuk dan spam untuk tautan pengaturan ulang kata sandi. Jika belum menerima tautan, coba lagi.",
    "auth.checking": "Memeriksa sesi...",
    "auth.create": "Buat akun",
    "auth.register.title": "Daftar",
    "auth.register.trialNote": "Uji coba 7 hari dimulai saat akun dibuat.",
    "auth.register.submit": "Buat akun",
    "auth.register.busy": "Membuat akun...",
    "auth.register.passwordHint": "Gunakan minimal 8 karakter.",
    "auth.register.signin": "Sudah memiliki akun? Masuk",
    "auth.signin": "Masuk",
    "layer.inference": "Inferensi AI",
    "landing.eyebrow": "Ruang kerja keputusan",
    "landing.title": "Tahu yang penting. Putuskan yang harus dilakukan.",
    "landing.lede": "AXORIS menyusun fakta Anda menjadi ringkasan keputusan yang rapi. Rekomendasi terpisah dari keputusan. Anda yang memutuskan.",
    "landing.layers": "Tiga lapisan, tidak tercampur",
    "landing.factsBody": "Item Diketahui, Diasumsikan, dan Belum diketahui yang Anda konfirmasi. Ditampilkan apa adanya, bukan parafrase.",
    "landing.inferenceBody": "Rekomendasi berlabel jelas dengan tingkat keyakinan berupa angka. Bukan keputusan.",
    "landing.decisionBody": "Pilihan dan alasan Anda tersimpan ketika keputusan dicatat.",
    "landing.steps": "Dari pertanyaan hingga tindak lanjut.",
    "landing.step1t": "Tulis pertanyaan",
    "landing.step1d": "Tentukan pertanyaan, cakrawala waktu, dan sedikitnya dua opsi.",
    "landing.step2t": "Susun ringkasan keputusan",
    "landing.step2d": "Tinjau kerangka, risiko, konsekuensi setiap opsi, dan rekomendasi.",
    "landing.step3t": "Uji pemikiran",
    "landing.step3d": "Uji asumsi dan cari hal yang belum dipertimbangkan. Rekomendasi awal tetap tersimpan.",
    "landing.step4t": "Catat keputusan",
    "landing.step4d": "Pilih opsi, tulis alasan, lalu tetapkan langkah berikutnya dan tanggal tinjau.",
    "landing.library": "Akses bacaan pilihan untuk memperdalam kerangka berpikir. Simpan gagasan penting dalam catatan Anda, lalu kembali saat membutuhkannya.",
    "landing.principle": "AXORIS merekomendasikan,\nAnda memutuskan.",
    "landing.policy": "Buka kebijakan",
    "landing.visual.sectionNav": "Bagian halaman AXORIS",
    "landing.visual.architecture": "Cara kerja",
    "landing.visual.values": "Manfaat",
    "landing.visual.process": "Alur keputusan",
    "landing.visual.access": "Akses AXORIS",
    "landing.visual.eyebrow": "Ruang kerja keputusan eksekutif",
    "landing.visual.lede": "Kepala staf digital untuk memetakan fakta, menimbang pilihan, dan mencatat keputusan sebagai dasar penyusunan strategi.",
    "landing.hero.how": "Lihat cara kerjanya",
    "landing.visual.trial": "Mulai uji coba",
    "landing.visual.trialShort": "Mulai uji coba",
    "landing.faq.nav": "Pertanyaan umum",
    "landing.faq.eyebrow": "Pertanyaan umum",
    "landing.faq.title": "Sebelum Anda mulai.",
    "landing.faq.lede": "Pahami cara kerja, akses, dan kendali atas data Anda.",
    "landing.trust.title": "Kendali tetap pada Anda.",
    "landing.trust.body": "Pemrosesan AI mengikuti persetujuan Anda. Autentikasi dua faktor tersedia sebagai pilihan melalui Akun.",
    "landing.faq.decision.question": "Apakah AI mengambil keputusan untuk saya?",
    "landing.faq.decision.answer": "AXORIS menyusun Inferensi AI sebagai bahan pertimbangan. Anda memilih opsi dan mencatat alasan keputusan. Pilihan yang berbeda dari rekomendasi tetap dicatat sebagai pilihan Anda.",
    "landing.faq.trial.question": "Bagaimana masa uji coba dihitung?",
    "landing.faq.trial.answer": "Masa uji coba akun publik berlangsung tujuh hari sejak akun dibuat. Verifikasi email dan persetujuan data diperlukan untuk melanjutkan ke ruang kerja.",
    "landing.faq.privacy.question": "Bagaimana data saya diproses?",
    "landing.faq.privacy.answer": "Persetujuan data diperlukan untuk menyimpan akun dan keputusan. Pemrosesan AI dan analitik memiliki persetujuan terpisah, keduanya mati secara bawaan. Jika pemrosesan AI dimatikan, model tidak dipanggil.",
    "landing.faq.security.question": "Apakah tersedia autentikasi dua faktor?",
    "landing.faq.security.answer": "Ya. Anda dapat mengaktifkan autentikasi dua faktor dengan aplikasi autentikator melalui Akun. Setelah diaktifkan, kode autentikator diperlukan saat masuk. Pengguna yang belum mengaktifkannya tetap dapat masuk seperti biasa.",
    "landing.faq.library.question": "Apakah buku Pustaka dapat diunduh?",
    "landing.faq.library.answer": "Pustaka dibaca di dalam AXORIS sesuai hak akses akun Anda. Unduhan buku tidak tersedia. Anda dapat menyimpan gagasan penting sebagai sorotan dan catatan di dalam aplikasi.",
    "landing.faq.individual.question": "Apakah AXORIS menyediakan ruang kerja tim?",
    "landing.faq.individual.answer": "Saat ini AXORIS menyediakan ruang kerja pribadi untuk pendiri bisnis, direktur, dan pengambil keputusan. Ruang kerja bersama serta kolaborasi tim belum tersedia.",
    "landing.closing.note": "Buat akun, verifikasi email, lalu atur persetujuan sebelum mulai.",
    "landing.pricing.nav": "Langganan",
    "landing.pricing.eyebrow": "Langganan AXORIS",
    "landing.pricing.title": "Pilih bulanan atau tahunan.",
    "landing.pricing.lede": "Dua pilihan periode untuk ruang kerja keputusan Anda.",
    "landing.pricing.monthly": "Bulanan",
    "landing.pricing.annual": "Tahunan",
    "landing.pricing.perMonth": "/ bulan",
    "landing.pricing.perYear": "/ tahun",
    "landing.pricing.saving": "Hemat {price}",
    "landing.pricing.equivalent": "Setara sekitar {price}/bulan",
    "landing.pricing.monthlyBody": "Periode langganan satu bulan.",
    "landing.pricing.annualBody": "Periode langganan satu tahun.",
    "landing.pricing.feature1": "Fakta, pilihan, dan ringkasan keputusan",
    "landing.pricing.feature2": "Catatan keputusan dan tindak lanjut",
    "landing.pricing.feature3": "Bacaan orisinal di Pustaka",
    "landing.pricing.availability": "Pembayaran belum tersedia saat ini. Anda dapat memulai uji coba terlebih dahulu.",
    "landing.pricing.loading": "Memuat harga…",
    "landing.pricing.empty": "Harga belum tersedia. Anda tetap dapat memulai uji coba.",
    "landing.pricing.error": "Harga belum dapat dimuat. Silakan coba lagi.",
    "landing.pricing.retry": "Muat ulang harga",
    "landing.pricing.pending": "Harga belum tersedia",
    "landing.visual.signalAi": "AXORIS merekomendasikan",
    "landing.visual.signalUser": "Anda memutuskan",
    "landing.visual.layers": "Tiga Lapisan Keputusan",
    "landing.visual.layersLede": "Pemisahan antara item yang Anda konfirmasi, inferensi AI, dan pilihan yang Anda catat.",
    "landing.visual.aiBoundary": "Rekomendasi, bukan pilihan Anda",
    "landing.visual.choiceRecorded": "Pilihan dan alasan keputusan dicatat oleh Anda",
    "landing.visual.userBoundary": "Otoritas tetap di tangan Anda",
    "landing.visual.valuesTitle": "Lebih jelas sebelum memilih. Tetap terarah setelahnya.",
    "landing.visual.valuesLede": "Struktur kerja untuk konteks yang tersebar, pilihan yang tertunda, dan tindak lanjut yang mudah terlewat.",
    "landing.visual.value1t": "Konteks lebih jelas",
    "landing.visual.value1d": "Satukan informasi yang tersebar dalam konteks keputusan. Apa yang diketahui, diasumsikan, dan belum diketahui terlihat jelas.",
    "landing.visual.value1n": "Diketahui · Diasumsikan · Belum diketahui",
    "landing.visual.value2t": "Pilihan yang beralasan",
    "landing.visual.value2d": "Timbang konsekuensi setiap opsi sebelum memilih. Rekomendasi menjadi bahan pertimbangan; keputusan tetap di tangan Anda.",
    "landing.visual.value2n": "Ringkasan keputusan",
    "landing.visual.value3t": "Tindak lanjut yang terlihat",
    "landing.visual.value3d": "Simpan langkah berikutnya dan tanggal tinjau ketika mencatat keputusan. Perhatian membantu Anda kembali pada keputusan yang perlu mendapat perhatian.",
    "landing.visual.value3n": "Pencatatan keputusan · Perhatian",
    "landing.story.title": "Satu pertanyaan. Tiga lapisan yang jelas.",
    "landing.narrative.question": "Pertanyaan",
    "landing.narrative.brief": "Ringkasan keputusan",
    "landing.narrative.choice": "Keputusan",
    "landing.narrative.followThrough": "Tindak lanjut",
    "landing.narrative.review": "Tindak lanjut",
    "landing.narrative.controls": "Tahapan contoh produk",
    "landing.narrative.play": "Putar contoh",
    "landing.narrative.pause": "Jeda contoh",
    "landing.narrative.previous": "Tahap sebelumnya",
    "landing.narrative.next": "Tahap berikutnya",
    "landing.narrative.running": "Alur otomatis · 21 detik",
    "landing.narrative.paused": "Dijeda · pilih tahap untuk menjelajah",
    "landing.narrative.static": "Alur statis · gerak dikurangi",
    "landing.narrative.cash": "Catatan kas",
    "landing.narrative.market": "Asumsi pasar",
    "landing.narrative.operations": "Pertanyaan operasi",
    "landing.narrative.focus": "Dari konteks tersebar, menjadi satu pertanyaan.",
    "landing.narrative.confirmed": "Status dikonfirmasi pengguna",
    "landing.narrative.aiReason": "Alasan rekomendasi",
    "landing.narrative.humanReason": "Alasan pengguna",
    "landing.narrative.follow": "Ikuti rekomendasi",
    "landing.narrative.other": "Pilih opsi lain",
    "landing.narrative.choiceHint": "Coba ikuti rekomendasi atau pilih opsi lain. Keduanya dicatat tanpa penilaian benar atau salah.",
    "landing.narrative.followRationale": "Saya memilih menunda agar cadangan kas tetap tersedia selama asumsi pasar diperiksa.",
    "landing.narrative.commit": "Catat keputusan contoh",
    "landing.narrative.commitActor": "Simulasi: pengguna mencatat keputusan",
    "landing.narrative.recorded": "Keputusan dicatat.",
    "landing.narrative.saved": "Langkah berikutnya dan tanggal tinjau telah disimpan.",
    "landing.narrative.note": "Demo ilustratif. Pilihan, alasan, langkah berikutnya, dan tanggal tinjau adalah contoh; interaksi di sini tidak menyimpan data atau menggunakan AI.",
    "landing.narrative.noJs": "Contoh statis AXORIS. Aktifkan JavaScript untuk menggunakan aplikasi dan kontrol demo.",
    "landing.story.lede": "Lihat bagaimana fakta, asumsi, dan ketidakpastian menjadi bahan pertimbangan untuk keputusan Anda.",
    "landing.story.factNote": "Item dikonfirmasi oleh pengguna. Diketahui, Diasumsikan, dan Belum diketahui tetap dibedakan.",
    "landing.story.weighOptions": "Menimbang opsi",
    "landing.story.exampleNote": "Contoh ilustratif. Langkah berikutnya dan tanggal tinjau ditambahkan untuk memperlihatkan tindak lanjut, bukan data akun Anda.",
    "landing.story.attentionTitle": "Keputusan tercatat. Perhatian tetap terjaga.",
    "landing.story.attentionBody": "Perhatian menampilkan hingga tiga keputusan. Keputusan yang Anda tandai didahulukan, lalu tanggal tinjau dalam tujuh hari, informasi yang belum diketahui, dan langkah berikutnya.",
    "landing.story.attentionRule": "Jika tanggal Harus dipilih terlewati, keputusan yang belum dicatat dapat mengisi slot tersisa.",
    "landing.story.attentionCount": "1 dari 3",
    "landing.story.pinnedByYou": "Penanda Anda",
    "landing.story.recorded": "Tercatat",
    "landing.story.attentionExampleNote": "Contoh keputusan yang ditandai pengguna untuk ditinjau kembali.",
    "landing.visual.accessTitle": "Akses dimulai dari akun Anda",
    "landing.visual.accessBody": "Masa uji coba berlangsung tujuh hari sejak akun dibuat. Verifikasi email dan persetujuan data diperlukan; penggunaan AI mengikuti persetujuan Anda dan kuota yang berlaku.",
    "landing.visual.footerLede": "Kepala staf digital untuk ruang kerja keputusan Anda.",
    "landing.visual.footerWorkspace": "Ruang Kerja AXORIS",
    "landing.visual.footerPolicy": "Privasi & Ketentuan",
    "landing.visual.privacy": "Kebijakan Privasi",
    "landing.visual.terms": "Syarat Layanan",
    "landing.visual.dpa": "Pemrosesan Data",
    "err.name": "Gunakan nama tampilan minimal 2 karakter.",
    "err.email": "Gunakan email yang valid.",
    "err.password.min": "Minimal 8 karakter.",
    "err.exists": "Email ini sudah terdaftar. Masuk dengan akun Anda.",
    "err.register": "Akun belum berhasil dibuat. Coba lagi.",
    "err.registerPartial": "Akun sudah dibuat, tetapi penyiapannya belum selesai. Masuk untuk melanjutkan verifikasi email.",
    "err.credentials": "Email atau kata sandi tidak sesuai.",
    "verify.title": "Periksa email",
    "verify.body": "Buka tautan verifikasi di email untuk {email}, lalu masuk kembali untuk melanjutkan. Periksa juga folder spam. Jika tautan belum diterima, kirim ulang setelah hitungan mundur selesai.",
    "verify.bodyAnon": "Buka tautan verifikasi di email Anda, lalu masuk kembali untuk melanjutkan. Periksa juga folder spam. Untuk mengirim ulang tautan, masuk terlebih dahulu.",
    "verify.resend": "Kirim ulang tautan",
    "verify.signinAction": "Masuk kembali",
    "verify.resent": "Tautan verifikasi dikirim ulang. Periksa kotak masuk dan folder spam.",
    "verify.failed": "Tautan verifikasi belum berhasil dikirim. Coba lagi.",
    "verify.signinRequired": "Masuk terlebih dahulu untuk mengirim ulang tautan verifikasi.",
    "verify.alreadyVerified": "Email sudah terverifikasi. Masuk untuk melanjutkan.",
    "verify.wait": "Tunggu hingga hitungan mundur selesai sebelum mengirim ulang.",
    "consent.title": "Persetujuan",
    "consent.data.title": "Data akun",
    "consent.data.desc": "Izinkan penyimpanan data akun dan keputusan Anda. Persetujuan ini wajib untuk menggunakan ruang kerja.",
    "consent.data.required": "Wajib",
    "consent.ai.title": "Pemrosesan AI",
    "consent.ai.desc": "Opsional. Izinkan AI mengolah catatan dan menyusun ringkasan keputusan. Jika nonaktif, model tidak dipanggil dan keputusan tetap dapat dicatat secara manual.",
    "consent.analytics.title": "Analitik",
    "consent.analytics.desc": "Opsional. Izinkan pencatatan aktivitas penggunaan tanpa menyertakan teks keputusan, item, atau alasan keputusan.",
    "consent.on": "Aktif",
    "consent.off": "Nonaktif",
    "consent.continue": "Simpan dan lanjutkan",
    "consent.busy": "Menyimpan persetujuan...",
    "consent.fail": "Persetujuan belum tercatat. Coba lagi.",
    "consent.policy": "Baca kebijakan dan ketentuan",
    "policy.title": "Draf kebijakan",
    "filter.all": "Semua",
    "status.draft": "Draf",
    "status.composing": "Menyusun",
    "status.ready": "Siap ditinjau",
    "status.committed": "Tercatat",
    "status.deferred": "Ditunda",
    "mem.search": "Cari keputusan berdasarkan judul atau status",
    "decisions.workspace": "Ruang kerja keputusan",
    "decisions.lede": "Temukan keputusan Anda berdasarkan judul atau status, lalu buka untuk melihat konteksnya.",
    "decisions.horizon": "Cakrawala: {n} hari",
    "decisions.count": "{count} keputusan",
    "decisions.open": "Buka keputusan",
    "mem.searchPh": "Cari judul atau status",
    "mem.filters": "Filter status keputusan",
    "mem.empty": "Belum ada keputusan. Mulai dengan menuliskan pertanyaan yang sedang Anda hadapi.",
    "mem.emptyFilter": "Tidak ada keputusan yang cocok dengan pencarian dan filter ini. Ubah kata pencarian atau pilih status Semua.",
    "horizon.days": "{n} hari",
    "intake.step.question": "Pertanyaan",
    "intake.step.notes": "Catatan",
    "intake.step.items": "Item",
    "intake.step.options": "Opsi",
    "intake.stepSr": "Langkah {n}: {name}",
    "intake.back": "Kembali",
    "intake.example": "Lihat contoh",
    "intake.next": "Lanjutkan",
    "intake.saving": "Menyimpan draf...",
    "field.title": "Judul",
    "field.question": "Pertanyaan",
    "field.outcome": "Hasil yang diinginkan",
    "field.horizon": "Cakrawala keputusan",
    "intake.horizonHint": "Rentang waktu untuk mempertimbangkan dampak keputusan, bukan batas pilih.",
    "question.hint": "Tuliskan pertanyaan yang harus dijawab, bukan tugas.",
    "err.title": "Gunakan judul minimal 3 karakter.",
    "err.question": "Tuliskan pertanyaan keputusan minimal 12 karakter.",
    "err.item": "Item terlalu singkat.",
    "err.optName": "Nama opsi wajib.",
    "err.saveDraft": "Draf belum tercatat. Coba lagi.",
    "err.saveNote": "Catatan belum tercatat. Coba lagi.",
    "err.saveItem": "Item belum tercatat. Coba lagi.",
    "err.saveOption": "Opsi belum tercatat. Coba lagi.",
    "err.parse": "Catatan belum terurai. Coba lagi.",
    "err.compose": "Ringkasan keputusan belum tersusun. Coba lagi.",
    "notes.label": "Catatan",
    "notes.cut": "Batas 2.000 karakter telah tercapai.",
    "notes.parse": "Urai catatan",
    "notes.parsing": "Mengurai catatan...",
    "notes.toItems": "Lanjut ke item",
    "notes.saving": "Menyimpan catatan...",
    "ai.badge": "INFERENSI AI",
    "ai.noConsent": "Pemrosesan AI belum disetujui. Keputusan tetap dapat dicatat manual.",
    "ai.quotaOut": "Empat panggilan pada siklus ini sudah dipakai. Keputusan tetap dapat dicatat.",
    "ai.preview": "Periksa usulan sebelum menambahkannya sebagai item.",
    "ai.proposals": "Usulan item",
    "ai.quota": "{n} dari 4 tersisa",
    "items.suggested": "Usulan",
    "items.accept": "Terima",
    "items.edit": "Ubah",
    "items.discard": "Buang",
    "items.changeStatus": "Ubah status",
    "items.editTitle": "Ubah item",
    "items.save": "Simpan",
    "items.close": "Tutup",
    "items.addLabel": "Tambah item",
    "items.add": "Tambah",
    "items.status": "Status",
    "items.hint": "Tambahkan minimal satu item Diketahui atau Diasumsikan.",
    "opt.name": "Nama opsi",
    "opt.desc": "Deskripsi",
    "opt.rev": "Reversibilitas",
    "opt.add": "Tambah opsi",
    "opt.list": "Opsi",
    "opt.min": "Minimal dua opsi sebelum ringkasan keputusan.",
    "rev.easy": "Mudah",
    "rev.costly": "Mahal",
    "rev.hard": "Sulit",
    "brief.compose": "Susun ringkasan keputusan",
    "brief.composing": "Menyusun ringkasan keputusan...",
    "brief.skip": "Lanjut tanpa ringkasan keputusan",
    "dirty.title": "Perubahan belum disimpan.",
    "dirty.stay": "Tetap di sini",
    "dirty.discard": "Buang",
    "contoh.title": "Contoh",
    "example.badge": "CONTOH",
    "example.note": "Contoh ilustratif, bukan data akun Anda. Inferensi AI dan pilihan pengguna ditampilkan terpisah; halaman ini tidak menyimpan keputusan.",
    "example.briefNote": "Ringkasan contoh, bukan hasil pemrosesan akun Anda.",
    "example.back": "Kembali ke pengisian keputusan",
    "layer.facts": "Fakta Anda",
    "layer.decision": "Keputusan Anda",
    "rationale": "Alasan keputusan",
    "commit.differ": "Pilihan Anda berbeda dari Rekomendasi. Alasan keputusan Anda yang dicatat.",
    "brief.title": "Ringkasan keputusan",
    "brief.reviewNote": "Periksa rekomendasi sebelum mencatat keputusan Anda.",
    "brief.toc": "Isi ringkasan keputusan",
    "brief.framework": "Kerangka",
    "brief.assumptions": "Asumsi",
    "brief.unknowns": "Belum diketahui",
    "brief.tradeoffs": "Konsekuensi pilihan",
    "brief.recommendation": "Rekomendasi",
    "brief.change": "Kondisi untuk meninjau kembali",
    "brief.confidence": "Tingkat keyakinan AI",
    "refchip.aria": "Item {id}, buka teks asli",
    "item.source": "Sumber",
    "item.itemTitle": "Item {id}",
    "ws.all": "Semua keputusan",
    "ws.pin": "Pasang di Perhatian",
    "ws.unpin": "Lepas dari Perhatian",
    "ws.commit": "Catat keputusan",
    "ws.delete": "Hapus",
    "ws.facts": "Fakta Anda",
    "ws.brief": "Ringkasan keputusan",
    "ws.relatedChapters": "Bab terkait",
    "ws.compose": "Susun ringkasan keputusan",
    "ws.challenge": "Uji pemikiran saya",
    "ws.missing": "Apa yang belum saya pertimbangkan?",
    "ws.makeItem": "Jadikan item",
    "ws.continuity": "Periksa kesinambungan",
    "ws.nextAction": "Langkah berikutnya",
    "ws.review": "Tanggal tinjau",
    "ws.commitDate": "Tanggal pencatatan",
    "ws.deferred": "Ditunda",
    "err.pinMax": "Maksimal 3 keputusan dapat ditandai di Perhatian. Lepas salah satu penanda sebelum menambahkan yang lain.",
    "err.pin": "Penanda belum tercatat. Coba lagi.",
    "err.challenge": "Lampiran belum tersusun. Coba lagi.",
    "err.continuity": "Pemeriksaan belum selesai. Coba lagi.",
    "err.deleteOption": "Opsi belum terhapus. Coba lagi.",
    "err.load": "Tidak dapat memuat. Coba lagi.",
    "brief.abstain": "Tidak cukup konteks untuk menghasilkan ringkasan keputusan. Tambahkan item Diketahui atau Diasumsikan, lalu coba lagi.",
    "ai.kill": "Penyusunan AI sedang dijeda. Keputusan dan catatan tetap dapat dibaca.",
    "locked": "Akses Pustaka dan ringkasan keputusan dijeda. Catatan Anda tetap tersimpan.",
    "ws.notFound": "Keputusan tidak ditemukan.",
    "commit.title": "Keputusan Anda",
    "commit.recLabel": "Rekomendasi",
    "commit.defer": "Tunda",
    "commit.choosePlaceholder": "Pilih opsi keputusan",
    "commit.rationale": "Alasan keputusan",
    "commit.hint": "Tuliskan alasan Anda sendiri, minimal 20 karakter.",
    "commit.reviewHint": "Tanggal untuk meninjau kembali keputusan setelah dicatat, bukan batas pilih.",
    "commit.nextAction": "Langkah berikutnya",
    "commit.reviewDate": "Tanggal tinjau",
    "commit.submit": "Catat keputusan",
    "commit.busy": "Mencatat keputusan...",
    "commit.ok": "Keputusan dicatat. Langkah berikutnya dan tanggal tinjau telah disimpan.",
    "commit.fail": "Keputusan belum tercatat. Coba lagi.",
    "err.rationale": "Tuliskan alasan keputusan minimal 20 karakter.",
    "att.review": "Tinjau dalam 7 hari",
    "att.unknown": "Informasi yang belum diketahui masih terbuka",
    "lib.title": "Bacaan",
    "lib.archive": "Pustaka / Bacaan pilihan",
    "lib.collectionLede": "Akses bacaan pilihan untuk memperdalam kerangka berpikir. Simpan gagasan penting dalam catatan Anda, lalu kembali saat membutuhkannya.",
    "lib.collection": "Koleksi bacaan",
    "lib.bookCount": "{n} bacaan",
    "lib.lede": "Teks orisinal AXORIS. Bukan toko.",
    "lib.empty": "Belum ada bacaan yang diterbitkan.",
    "lib.continue": "Lanjutkan membaca",
    "lib.lastRead": "Bacaan terakhir",
    "lib.failLoad": "Koleksi bacaan belum dapat dimuat. Coba lagi.",
    "lib.estimatedMinutes": "Sekitar {n} menit baca",
    "lib.minutes": "{n} menit",
    "lib.notesLink": "Catatan saya",
    "lib.locked": "Akses Pustaka dijeda. Catatan Anda tetap tersimpan.",
    "lib.lockedCard": "Terkunci",
    "book.read": "Lanjutkan membaca",
    "book.start": "Mulai membaca",
    "book.restore": "Kelola akses",
    "book.notFound": "Buku ini tidak ditemukan.",
    "book.failLoad": "Detail buku belum dapat dimuat. Coba lagi.",
    "book.chapters": "Daftar bab",
    "book.chapterCount": "{n} bab",
    "book.empty": "Belum ada bab yang tersedia.",
    "book.back": "Kembali ke Pustaka",
    "reader.toc": "Daftar isi",
    "reader.size": "Ukuran teks",
    "reader.theme": "Tema pembaca",
    "reader.bookmark": "Penanda baca",
    "reader.back": "Kembali ke detail buku",
    "reader.sizeValue": "Ukuran teks {n} piksel",
    "reader.toLight": "Gunakan tema baca terang",
    "reader.toDark": "Gunakan tema baca gelap",
    "reader.addBookmark": "Tandai bab ini",
    "reader.removeBookmark": "Hapus penanda bab ini",
    "reader.bookmarkFail": "Penanda belum tersimpan. Coba lagi.",
    "reader.progressFail": "Posisi baca belum tersimpan. Periksa koneksi Anda.",
    "reader.prev": "Bab sebelumnya",
    "reader.next": "Bab berikutnya",
    "reader.empty": "Isi bab ini belum tersedia.",
    "chapter.fail": "Bab ini belum dapat dimuat.",
    "chapter.notFound": "Bab ini tidak ditemukan.",
    "highlight.invalid": "Pilih kutipan maksimal 280 karakter.",
    "highlight.title": "Sorotan",
    "highlight.color": "Warna",
    "highlight.teal": "Hijau kebiruan",
    "highlight.gold": "Emas",
    "highlight.remark": "Catatan (opsional)",
    "highlight.remarkHint": "Maksimal 280 karakter.",
    "highlight.save": "Simpan sorotan",
    "err.saveHighlight": "Sorotan belum tercatat. Coba lagi.",
    "notes.title": "Catatan saya",
    "notes.collectionLede": "Tinjau kembali kutipan dan catatan dari bacaan Anda. Tambahkan kutipan yang relevan sebagai item pada keputusan.",
    "notes.count": "{n} sorotan",
    "notes.empty": "Belum ada sorotan. Pilih kutipan saat membaca buku untuk menyimpannya di sini.",
    "notes.remarkLabel": "Catatan Anda",
    "notes.open": "Buka bab",
    "notes.journal": "Tambahkan ke keputusan",
    "journal.saved": "Kutipan ditambahkan sebagai item Diasumsikan. Tinjau statusnya pada keputusan Anda.",
    "journal.pick": "Pilih keputusan tujuan",
    "journal.hint": "Kutipan ditambahkan sebagai item Diasumsikan, bukan fakta terkonfirmasi. Catatan pribadi tetap di Pustaka. Ringkasan aktif perlu disusun kembali.",
    "journal.create": "Buat draf keputusan",
    "journal.done": "Sudah ditambahkan ke keputusan",
    "acc.workspaceTitle": "Pengaturan akun",
    "acc.lede": "Kelola preferensi tampilan, akses, privasi, dan keamanan akun Anda.",
    "acc.prefs": "Preferensi tampilan",
    "acc.cadenceFailed": "Preferensi email belum disimpan. Coba lagi.",
    "acc.lang": "Bahasa",
    "acc.theme": "Tema",
    "theme.light": "Terang",
    "theme.dark": "Gelap",
    "theme.system": "Sistem",
    "acc.cadence": "Email hanya bila ada perubahan material.",
    "acc.sub": "Langganan",
    "acc.accountType": "Tipe akun",
    "acc.period": "Periode",
    "acc.trialUntil": "Uji coba sampai",
    "acc.pilotPermanent": "Akun Pilot aktif tanpa batas waktu.",
    "acc.accessLoading": "Memuat akses akun…",
    "acc.accessUnavailable": "Akses akun belum dapat dimuat.",
    "acc.accessExpired": "Akses berakhir",
    "acc.accessPastDue": "Akses terkunci",
    "acc.accessNone": "Belum aktif",
    "acc.retry": "Coba lagi",
    "acc.photoChange": "Ubah foto",
    "acc.photoLoading": "Memuat foto…",
    "acc.photoSave": "Simpan foto",
    "acc.photoCancel": "Batal",
    "acc.photoReadFailed": "Foto belum dapat dimuat.",
    "acc.photoWriteFailed": "Foto belum disimpan. Coba lagi.",
    "acc.photoInvalid": "Pilih JPEG, PNG, atau WebP, maksimal 2 MB.",
    "mfa.title": "Autentikasi dua faktor",
    "mfa.active": "Aktif. Autentikator sudah terdaftar.",
    "mfa.inactive": "Belum aktif.",
    "mfa.optionalNote": "2FA opsional. Jika belum diaktifkan, Anda bisa masuk seperti biasa. Setelah aktif, kode autentikator diperlukan saat masuk.",
    "mfa.enable": "Aktifkan 2FA",
    "mfa.disable": "Nonaktifkan autentikator",
    "mfa.addBackup": "Tambah autentikator cadangan",
    "mfa.authenticator": "Autentikator",
    "mfa.backupNote": "Simpan cadangan autentikator sesuai petunjuk aplikasinya.",
    "mfa.factorLimit": "Autentikator sudah terdaftar. Nonaktifkan faktor yang ada sebelum menggantinya.",
    "mfa.localUnavailable": "Aktivasi TOTP belum tersedia di emulator lokal. Uji nyata memerlukan Firebase dengan Identity Platform.",
    "mfa.unavailable": "Autentikasi dua faktor belum tersedia. Coba lagi nanti atau hubungi bantuan akun.",
    "mfa.actionFailed": "Verifikasi belum berhasil. Coba lagi atau masuk ulang.",
    "mfa.codeFailed": "Verifikasi belum berhasil. Gunakan kode terbaru dari aplikasi autentikator dan coba lagi.",
    "mfa.code": "Kode 6 digit",
    "mfa.verify": "Verifikasi kode",
    "mfa.challengeNote": "Masukkan kode enam digit dari aplikasi autentikator Anda untuk melanjutkan.",
    "mfa.unsupported": "Metode verifikasi akun ini belum didukung. Hubungi bantuan akun.",
    "mfa.currentPassword": "Kata sandi saat ini",
    "mfa.continue": "Verifikasi identitas",
    "mfa.googleReauth": "Verifikasi dengan Google",
    "mfa.reauthNote": "Verifikasi identitas sebelum menambahkan autentikator.",
    "mfa.removeNote": "Verifikasi identitas untuk menonaktifkan faktor ini.",
    "mfa.scanNote": "Pindai QR dengan aplikasi autentikator, lalu masukkan kode yang muncul.",
    "mfa.qrAlt": "QR untuk menambahkan AXORIS ke autentikator",
    "mfa.manualKey": "Atau masukkan kunci ini secara manual:",
    "mfa.enabled": "Autentikator berhasil ditambahkan.",
    "mfa.removed": "Autentikator berhasil dinonaktifkan.",
    "mfa.expired": "Waktu penyiapan berakhir. Mulai lagi untuk mendapatkan kunci baru.",
    "mfa.loginExpired": "Sesi verifikasi tidak lagi valid. Pilih Batal, lalu masuk kembali untuk memulai sesi baru.",
    "mfa.passwordReauth": "Verifikasi identitas kembali sebelum menyimpan kata sandi baru.",
    "sub.price": "Harga",
    "sub.method": "Metode",
    "sub.date.trialing": "Tagihan pertama",
    "sub.date.active": "Perpanjangan",
    "sub.date.canceled": "Akses sampai",
    "sub.date.past_due": "Jatuh tempo",
    "sub.date.expired": "Berakhir",
    "sub.none": "Belum ada langganan.",
    "sub.pilotNotice": "Akses pilot melalui undangan.",
    "acc.accessPilot": "Pilot",
    "acc.accessTrial": "Uji coba",
    "acc.accessPremium": "Premium",
    "sub.contactSupport": "Hubungi dukungan",
    "sub.trialNotice": "Uji coba akun publik berlangsung tujuh hari sejak akun dibuat. Tidak ada penagihan otomatis.",
    "sub.premiumNotice": "Akses Premium tercatat pada akun Anda.",
    "sub.expiredNotice": "Masa akses Anda sudah berakhir. Catatan Anda tetap tersimpan. Pembayaran belum tersedia saat ini.",
    "sub.unavailableNotice": "Akses akun Anda belum aktif. Catatan Anda tetap tersimpan. Hubungi dukungan jika Anda membutuhkan bantuan.",
    "sub.accessUntil": "Akses hingga",
    "sub.start": "Mulai langganan",
    "sub.cancel": "Batalkan langganan",
    "sub.cancelBody": "Akses berlanjut sampai akhir periode yang sudah dibayar.",
    "sub.keep": "Tetap",
    "err.cancel": "Langganan belum dibatalkan. Coba lagi.",
    "acc.privacy": "Privasi dan data",
    "acc.exportTitle": "Arsip data akun (JSON)",
    "acc.export": "Ekspor JSON",
    "acc.exporting": "Mengekspor...",
    "acc.exportFail": "Gagal mengekspor data akun. Coba lagi nanti.",
    "acc.exportNote": "Keputusan, sorotan, dan persetujuan. Tanpa analitik.",
    "acc.delete": "Hapus akun",
    "acc.deleting": "Menghapus...",
    "acc.deleteBody": "Akun beserta data keputusan, lembar, sorotan, persetujuan, dan foto profil Anda akan dihapus permanen. Tindakan ini tidak dapat dibatalkan.",
    "acc.deleteField": "Ketik HAPUS",
    "acc.deleteHint": "Ketik HAPUS untuk melanjutkan.",
    "err.delete": "Gagal menghapus akun. Coba lagi.",
    "acc.security": "Keamanan akun",
    "acc.passwordHint": "Gunakan 8–72 karakter.",
    "acc.keepAccount": "Pertahankan akun",
    "acc.status": "Status",
    "acc.pwFailed": "Kata sandi belum diperbarui. Coba lagi atau masuk ulang.",
    "acc.newPw": "Kata sandi baru",
    "acc.pwSave": "Ubah kata sandi",
    "acc.pwSaved": "Kata sandi diperbarui.",
    "acc.signout": "Keluar",
    "acc.signingOut": "Keluar...",
    "acc.totp": "TOTP",
    "acc.totpNote": "Tidak wajib pada paket ini.",
    "acc.totpPreview": "Preferensi pratinjau saja; tidak mengaktifkan autentikasi dua faktor.",
    "plan.title": "Langganan",
    "plan.priceHint": "Bandingkan harga paket bulanan dan tahunan. Memilih periode belum mengaktifkan langganan.",
    "plan.resultNote": "Status ini berasal dari data akun Anda, bukan konfirmasi pembayaran.",
    "plan.seg": "Periode langganan",
    "plan.monthly": "Bulanan",
    "plan.annual": "Tahunan",
    "plan.perMonth": "/ bulan",
    "plan.perYear": "/ tahun",
    "plan.eq": "setara {price} / bulan",
    "plan.save": "Hemat {price}",
    "plan.trial": "Akun publik mendapat uji coba tujuh hari sejak akun dibuat. Akun Pilot aktif tanpa batas waktu.",
    "plan.availability": "Ketersediaan pembayaran",
    "plan.paymentNotice": "Pembayaran belum tersedia saat ini.",
    "plan.paymentUnavailable": "Pembayaran belum tersedia",
    "plan.noBilling": "Saat ini tidak ada tanggal tagihan atau penagihan otomatis.",
    "plan.loading": "Memuat harga langganan…",
    "plan.pricesUnavailable": "Harga langganan belum dapat dimuat. Coba lagi.",
    "plan.accessTitle": "Status akses Anda",
    "plan.unconfirmed": "Status akses belum dapat dikonfirmasi. Coba lagi atau periksa melalui Akun.",
    "plan.toAccount": "Buka Akun",
    "trial.h2": "Uji coba Anda berakhir pada {date}. Tidak ada penagihan otomatis.",
    "banner.manage": "Kelola",
    "nav.sheet": "Lembar",
    "sheet.title": "Lembar",
    "sheet.listWorkspace": "Ruang kerja eksekutif",
    "sheet.listEyebrow": "Catatan & pertimbangan",
    "sheet.listLede": "Ruang untuk tujuan, jurnal, dan pertimbangan sebelum menjadi keputusan.",
    "sheet.listCount": "{count} catatan",
    "sheet.listOpen": "Buka lembar",
    "sheet.listEmptyHint": "Mulai dengan tujuan, jurnal, atau catatan yang ingin Anda telaah.",
    "sheet.lede": "Tulis apa yang belum jadi keputusan.",
    "sheet.empty": "Belum ada lembar.",
    "sheet.new": "Lembar baru",
    "sheet.save": "Simpan",
    "sheet.saveAdd": "Simpan tambahan",
    "sheet.saved": "Tersimpan.",
    "sheet.body": "Catatan Anda",
    "sheet.classification": "Jenis lembar",
    "sheet.draft": "Draf",
    "sheet.status.open": "Catatan",
    "sheet.characters": "{count} karakter",
    "sheet.synthesis": "Bacaan catatan",
    "sheet.hint": "Tujuan, jurnal, sasaran, objektif, atau apa pun yang belum jadi keputusan.",
    "sheet.read": "Minta bacaan",
    "sheet.reading": "Menyusun bacaan catatan…",
    "sheet.add": "Tambah catatan",
    "sheet.addLabel": "Tambahan Anda",
    "sheet.promote": "Buat draf keputusan",
    "sheet.promoteCta": "Buat draf",
    "sheet.promoted": "Draf keputusan dibuat. Lembar ini tetap tersimpan.",
    "sheet.promoteNote": "Pertanyaan dan judul berikut menjadi draf keputusan. Item dan opsi perlu Anda isi. Lembar tetap tersimpan.",
    "sheet.cancel": "Batal",
    "sheet.quota": "Batas bacaan tercapai. Anda tetap dapat menyimpan catatan. Draf keputusan dapat dibuat dari pertanyaan yang sudah tersedia.",
    "sheet.aiOff": "Bacaan AI belum diizinkan. Anda tetap dapat menyimpan catatan. Kelola persetujuan AI di pengaturan privasi.",
    "sheet.abstain": "Catatan ini belum cukup untuk menyusun bacaan dan pertanyaan keputusan. Tambahkan konteks yang relevan.",
    "sheet.failSave": "Lembar belum tersimpan. Coba lagi.",
    "sheet.failRead": "Bacaan belum tersedia. Coba lagi.",
    "sheet.failLoad": "Lembar belum dapat dimuat.",
    "sheet.searchEmpty": "Tidak ada lembar yang cocok dengan pencarian pada filter ini. Ubah kata pencarian atau pilih filter lain.",
    "sheet.filterEmpty": "Belum ada lembar pada filter ini. Pilih filter lain untuk melihat lembar Anda.",
    "sheet.searchPh": "Cari judul atau cuplikan isi",
    "sheet.filters": "Filter lembar",
    "sheet.kind": "Jenis",
    "sheet.titleLabel": "Judul (opsional)",
    "sheet.titlePh": "Judul lembar, jika diperlukan",
    "sheet.date": "Tanggal catatan",
    "sheet.menu": "Tindakan lembar",
    "sheet.park": "Parkir",
    "sheet.archive": "Arsipkan",
    "sheet.delete": "Hapus lembar ini? Keputusan yang dibuat dari lembar ini tidak ikut terhapus.",
    "sheet.deleteCta": "Hapus",
    "sheet.keep": "Pertahankan lembar",
    "sheet.question": "Pertanyaan",
    "sheet.draftTitle": "Judul draf",
    "sheet.sumHead": "Ringkasan",
    "sheet.seenHead": "Yang terlihat",
    "sheet.unclearHead": "Yang belum jelas",
    "sheet.raiseHead": "Pertanyaan untuk draf keputusan",
    "sheet.limit": "Batas tiga catatan per lembar tercapai. Mulai lembar baru untuk topik yang berbeda.",
    "sheet.errVersion": "Lembar berubah di tempat lain. Muat ulang.",
    "sheet.errClosed": "Catatan ini sudah dibaca. Tambah catatan baru.",
    "sheet.errDisabled": "Bacaan AXORIS sedang tidak tersedia.",
    "sheet.errNoread": "Tambah catatan sebelum bacaan berikutnya.",
    "sheet.errText": "Isi catatan harus terdiri dari 20–6.000 karakter.",
    "sheet.errAdd": "Tambahan harus terdiri dari 20–2.000 karakter.",
    "sheet.errTitleMax": "Judul maksimal 80 karakter.",
    "sheet.errDate": "Tanggal tidak valid.",
    "sheet.status.parked": "Diparkir",
    "sheet.status.promoted": "Diangkat",
    "sheet.status.archived": "Diarsip",
    "kind.free": "Bebas",
    "kind.goal": "Tujuan",
    "kind.target": "Sasaran",
    "kind.objective": "Objektif",
    "kind.journal": "Jurnal",
    "open": "Buka",
  },
  en: {
    "beta.label": "Testing beta",
    "beta.notice": "Briefs are simulations, not AI model outputs. Sheets are stored on your device. Payments and recurring emails are not available yet.",
    "beta.deleteUnavailable": "Self-service deletion is not available in this beta. Contact halo@axoris.id to request account deletion.",
    "auth.session.failed": "Your account status could not be checked. Try again to continue.",
    "intake.resume": "Complete decision",
    "policy.page.title": "Privacy policy and terms",
    "policy.page.dates": "Effective 6 October 2026. Copy updated 11 October 2026.",
    "policy.page.privacy": "Privacy policy",
    "policy.page.terms": "Terms of use",
    "policy.page.processing": "Data processing overview",
    "policy.page.account": "Your account is created when you register. Consent to account data processing is required to use the AXORIS workspace.",
    "policy.page.consent": "AI processing and analytics have separate consent settings. Both are off by default. When AI consent is off, the model is not called.",
    "policy.page.stored": "Stored data includes account information, a profile photo if uploaded, decisions with their items, options and briefs, sheets, highlights, bookmarks, reading progress, and your consent settings.",
    "policy.page.export": "The JSON export on the Account page includes decisions with their items, options, next actions, dates, brief history and trigger checklists, highlights, and consent settings. It excludes analytics and book chapter content.",
    "policy.page.delete": "Deleting your account requires typing HAPUS exactly as shown on the Account page. Once deletion succeeds, your account, workspace data and profile photo are permanently deleted.",
    "policy.page.access": "Public accounts receive a seven-day trial from account creation. Pilot accounts have access with no expiry. Payments are not available; there is currently no billing date or automatic billing.",
    "policy.page.decision": "AXORIS provides recommendations. You choose an option and record your reasoning. Choices that differ from the recommendation are recorded neutrally.",
    "policy.page.library": "The Library contains AXORIS reading material available according to your account access. Books are read in AXORIS; book downloads are not available. Your notes remain saved when reading access ends.",
    "policy.page.price": "Selecting a monthly or annual period and viewing prices does not activate a subscription or start billing.",
    "policy.page.providers": "AXORIS uses Firebase for account and data services and Cloudflare to serve the website. Recurring application emails are not enabled yet.",
    "policy.page.payment": "Payment integration is not active. This overview will be updated when services or data processing change.",

    "language.id": "Indonesian",
    "language.en": "English",
    "epistemic.KNOWN": "Known",
    "epistemic.ASSUMED": "Assumed",
    "epistemic.UNKNOWN": "Unknown",
    "continuity.HOLDS": "Holds",
    "continuity.ADJUST": "Adjust",
    "continuity.REVIEW": "Review",
    "acc.accountPublic": "Public account",
    "landing.language": "Page language",
    "workspace.back": "Back to Decisions",
    "commit.back": "Back to Decision Brief",
    "commit.placeholder": "Describe the main consideration behind your choice.",
    "workspace.briefVersion": "Brief · v{n}",
    "workspace.recordTitle": "Choice & rationale",
    "workspace.recordHint": "Choose an option and write your reason when recording the decision.",
    "workspace.briefEmpty": "No Decision Brief has been composed yet.",
    "chooseBy.label": "Choose by",
    "chooseBy.empty": "No choice date",
    "chooseBy.wib": "Choice dates follow WIB.",
    "chooseBy.save": "Save date",
    "chooseBy.saved": "Choice date saved.",
    "chooseBy.error": "The choice date was not saved. Try again.",
    "trigger.occurred": "Trigger occurred",
    "trigger.error": "The checkbox was not saved. Try again.",
    "att.unselected": "not yet chosen",
    "app.name": "AXORIS",
    "skip": "Skip to content",
    "nav.main": "Main navigation",
    "nav.attention": "Attention",
    "nav.decisions": "Decisions",
    "nav.library": "Library",
    "nav.account": "Account",
    "nav.collapse": "Collapse sidebar",
    "nav.expand": "Expand sidebar",
    "decision.new": "New decision",
    "attention.empty": "Nothing requires attention. That is a sound state.",
    "attention.lede": "Decisions you pinned and those needing follow-up, in one queue.",
    "attention.active": "Decisions: {count}",
    "attention.quiet": "Queue is clear",
    "attention.queue": "Needs attention ({count})",
    "attention.nextAction": "Next action",
    "attention.pinned": "Pinned",
    "attention.reviewCta": "Open decision",
    "attention.quietBody": "No decisions need to appear in Attention right now. You can open the Decisions list or create a new decision.",
    "attention.todaySheet": "Today's sheet",
    "error.read": "Unable to load. Try again.",
    "retry": "Try again",
    "field.name": "Display name",
    "field.email": "Email",
    "field.password": "Password",
    "auth.or": "or",
    "auth.google": "Sign in with Google",
    "auth.login.title": "Sign in",
    "auth.login.lede": "Access your decision workspace.",
    "auth.login.stitchLede": "Access your executive decision workspace.",
    "auth.login.stitchLedeDesktop": "Sign in to your executive decision workspace.",
    "auth.login.googleDivider": "or sign in with",
    "auth.login.googleDesktop": "Sign in with Google",
    "auth.login.registerDesktop": "Sign up",
    "auth.login.access": "Account access",
    "auth.login.back": "Back to AXORIS",
    "auth.login.forgotLink": "Forgot password?",
    "auth.login.registerPrompt": "Don't have an account?",
    "auth.login.registerLink": "Create an account",
    "auth.login.help": "Support:",
    "auth.login.policy": "Policies & terms",
    "auth.login.emailPlaceholder": "name@company.com",
    "auth.login.failed": "Unable to sign in. Check your email and password, then try again.",
    "auth.login.unavailable": "Sign-in could not be completed. Try again when your connection or the service is available.",
    "auth.google.failed": "Unable to sign in with Google. Please try again.",
    "auth.showPw": "Show password",
    "auth.hidePw": "Hide password",
    "auth.login.submit": "Sign in",
    "auth.login.busy": "Signing in...",
    "auth.forgot": "Forgot password",
    "auth.forgot.sent": "Check your inbox and spam for a password reset link. If you have not received one, try again.",
    "auth.checking": "Checking your session...",
    "auth.create": "Create account",
    "auth.register.title": "Sign up",
    "auth.register.trialNote": "Your 7-day trial begins when your account is created.",
    "auth.register.submit": "Create account",
    "auth.register.busy": "Creating account...",
    "auth.register.passwordHint": "Use at least 8 characters.",
    "auth.register.signin": "Already have an account? Sign in",
    "auth.signin": "Sign in",
    "layer.inference": "AI inference",
    "landing.eyebrow": "A decision workspace",
    "landing.title": "Know what matters. Decide what to do.",
    "landing.lede": "AXORIS turns your facts into a tidy Decision Brief. Recommendations kept apart from decisions. You decide.",
    "landing.layers": "Three layers, never mixed",
    "landing.factsBody": "Known, Assumed, and Unknown items you confirm. Shown as they are, not paraphrased.",
    "landing.inferenceBody": "Clearly labeled recommendations with numeric confidence. Not decisions.",
    "landing.decisionBody": "Your choice and rationale, recorded at commit.",
    "landing.steps": "From question to follow-through.",
    "landing.step1t": "Write the question",
    "landing.step1d": "Define your question, time horizon, and at least two options.",
    "landing.step2t": "Compose the brief",
    "landing.step2d": "Review the framework, risks, trade-offs, and recommendation.",
    "landing.step3t": "Challenge the thinking",
    "landing.step3d": "Challenge assumptions and explore what you may have missed. The original recommendation stays saved.",
    "landing.step4t": "Record the decision",
    "landing.step4d": "Choose an option, write your rationale, then set a next action and review date.",
    "landing.library": "Access selected reading to deepen your thinking. Keep important ideas in your notes and return to them when you need them.",
    "landing.principle": "AXORIS recommends,\nYou decide.",
    "landing.policy": "Read the policy",
    "landing.visual.sectionNav": "AXORIS page sections",
    "landing.visual.architecture": "How it works",
    "landing.visual.values": "Benefits",
    "landing.visual.process": "Decision workflow",
    "landing.visual.access": "AXORIS Access",
    "landing.visual.eyebrow": "Executive decision workspace",
    "landing.visual.lede": "A digital Chief of Staff to map facts, weigh options, and record decisions that inform your strategy.",
    "landing.hero.how": "See how it works",
    "landing.visual.trial": "Start a trial",
    "landing.visual.trialShort": "Start a trial",
    "landing.faq.nav": "FAQ",
    "landing.faq.eyebrow": "Frequently asked questions",
    "landing.faq.title": "Before you begin.",
    "landing.faq.lede": "Understand how AXORIS works, your access, and your control over data.",
    "landing.trust.title": "You stay in control.",
    "landing.trust.body": "AI processing follows your consent. Two-factor authentication is an option available in Account.",
    "landing.faq.decision.question": "Does AI make decisions for me?",
    "landing.faq.decision.answer": "AXORIS prepares AI inference to inform your thinking. You choose an option and record your decision rationale. A choice that differs from the recommendation is still recorded as yours.",
    "landing.faq.trial.question": "When does the trial begin?",
    "landing.faq.trial.answer": "Public accounts receive a seven-day trial from account creation. Email verification and data consent are required to continue to the workspace.",
    "landing.faq.privacy.question": "How is my data processed?",
    "landing.faq.privacy.answer": "Data consent is required to store your account and decisions. AI processing and analytics have separate consent settings, both off by default. When AI processing is off, the model is not called.",
    "landing.faq.security.question": "Is two-factor authentication available?",
    "landing.faq.security.answer": "Yes. You can enable two-factor authentication with an authenticator app in Account. Once enabled, an authenticator code is required when signing in. Users who have not enabled it can sign in as usual.",
    "landing.faq.library.question": "Can I download Library books?",
    "landing.faq.library.answer": "Library is read within AXORIS according to your account access. Book downloads are not available. You can save ideas as highlights and notes within the app.",
    "landing.faq.individual.question": "Does AXORIS provide a team workspace?",
    "landing.faq.individual.answer": "AXORIS currently provides an individual workspace for founders, directors, and decision-makers. Shared workspaces and team collaboration are not yet available.",
    "landing.closing.note": "Create an account, verify your email, then set your consent preferences before you begin.",
    "landing.pricing.nav": "Subscription",
    "landing.pricing.eyebrow": "AXORIS subscription",
    "landing.pricing.title": "Choose monthly or annual.",
    "landing.pricing.lede": "Two subscription periods for your decision workspace.",
    "landing.pricing.monthly": "Monthly",
    "landing.pricing.annual": "Annual",
    "landing.pricing.perMonth": "/ month",
    "landing.pricing.perYear": "/ year",
    "landing.pricing.saving": "Save {price}",
    "landing.pricing.equivalent": "Approximately {price}/month",
    "landing.pricing.monthlyBody": "A one-month subscription period.",
    "landing.pricing.annualBody": "A one-year subscription period.",
    "landing.pricing.feature1": "Facts, options, and Decision Brief",
    "landing.pricing.feature2": "Decision records and follow-up",
    "landing.pricing.feature3": "Original reading in Library",
    "landing.pricing.availability": "Payments are not available yet. You can start a trial first.",
    "landing.pricing.loading": "Loading prices…",
    "landing.pricing.empty": "Prices are not available yet. You can still start a trial.",
    "landing.pricing.error": "Prices could not be loaded. Please try again.",
    "landing.pricing.retry": "Reload prices",
    "landing.pricing.pending": "Price not available",
    "landing.visual.signalAi": "AXORIS recommends",
    "landing.visual.signalUser": "You decide",
    "landing.visual.layers": "Three Decision Layers",
    "landing.visual.layersLede": "Items you confirm, AI inference, and the choice you record are kept separate.",
    "landing.visual.aiBoundary": "A recommendation, not your choice",
    "landing.visual.choiceRecorded": "Choice and decision rationale recorded by you",
    "landing.visual.userBoundary": "Authority remains with you",
    "landing.visual.valuesTitle": "Clarity before you choose. Direction after you decide.",
    "landing.visual.valuesLede": "A structure for scattered context, delayed choices, and follow-up that can slip from view.",
    "landing.visual.value1t": "Clearer context",
    "landing.visual.value1d": "Bring scattered information into the decision's context. What is known, assumed, and still unknown stays clear.",
    "landing.visual.value1n": "Known · Assumed · Unknown",
    "landing.visual.value2t": "Reasoned choices",
    "landing.visual.value2d": "Weigh each option's trade-offs before choosing. The recommendation informs your thinking; you stay in control of the decision.",
    "landing.visual.value2n": "Decision Brief",
    "landing.visual.value3t": "Visible follow-through",
    "landing.visual.value3d": "Save a next action and review date when recording your decision. Attention helps you return to decisions that need your attention.",
    "landing.visual.value3n": "Record decision · Attention",
    "landing.story.title": "One question. Three distinct layers.",
    "landing.narrative.question": "Question",
    "landing.narrative.brief": "Decision Brief",
    "landing.narrative.choice": "Decision",
    "landing.narrative.followThrough": "Follow-through",
    "landing.narrative.review": "Next steps",
    "landing.narrative.controls": "Product example stages",
    "landing.narrative.play": "Play example",
    "landing.narrative.pause": "Pause example",
    "landing.narrative.previous": "Previous stage",
    "landing.narrative.next": "Next stage",
    "landing.narrative.running": "Automatic flow · 21 seconds",
    "landing.narrative.paused": "Paused · choose a stage to explore",
    "landing.narrative.static": "Static flow · reduced motion",
    "landing.narrative.cash": "Cash note",
    "landing.narrative.market": "Market assumption",
    "landing.narrative.operations": "Operations question",
    "landing.narrative.focus": "Scattered context becomes one question.",
    "landing.narrative.confirmed": "Status confirmed by the user",
    "landing.narrative.aiReason": "Recommendation rationale",
    "landing.narrative.humanReason": "User rationale",
    "landing.narrative.follow": "Follow recommendation",
    "landing.narrative.other": "Choose another option",
    "landing.narrative.choiceHint": "Try following the recommendation or choosing another option. Neither choice is marked right or wrong.",
    "landing.narrative.followRationale": "I choose to defer so cash reserves remain available while the market assumption is checked.",
    "landing.narrative.commit": "Record example decision",
    "landing.narrative.commitActor": "Simulation: the user records the decision",
    "landing.narrative.recorded": "Decision recorded.",
    "landing.narrative.saved": "Next action and review date have been saved.",
    "landing.narrative.note": "Illustrative demo. Choices, reasons, next action, and review date are examples; these interactions neither save data nor use AI.",
    "landing.narrative.noJs": "A static AXORIS example. Enable JavaScript to use the app and demo controls.",
    "landing.story.lede": "See how facts, assumptions, and uncertainty inform a decision that remains yours.",
    "landing.story.factNote": "Items are confirmed by the user. Known, Assumed, and Unknown remain distinct.",
    "landing.story.weighOptions": "Weighing options",
    "landing.story.exampleNote": "Illustrative example. A next action and review date were added to show follow-through, not your account data.",
    "landing.story.attentionTitle": "Decision recorded. Follow-up in view.",
    "landing.story.attentionBody": "Attention shows up to three decisions for you to revisit. Pins come first, then reviews within seven days, open Unknowns, and next actions.",
    "landing.story.attentionRule": "An overdue Choose by date only fills remaining slots for decisions that have not been recorded.",
    "landing.story.attentionCount": "1 of 3",
    "landing.story.pinnedByYou": "Your pin",
    "landing.story.recorded": "Recorded",
    "landing.story.attentionExampleNote": "An example decision pinned by the user to revisit later.",
    "landing.visual.accessTitle": "Access begins with your account",
    "landing.visual.accessBody": "The trial lasts seven days from account creation. Email verification and data consent are required; AI use follows your consent and the applicable quota.",
    "landing.visual.footerLede": "A digital Chief of Staff for your decision workspace.",
    "landing.visual.footerWorkspace": "AXORIS Workspace",
    "landing.visual.footerPolicy": "Privacy & Terms",
    "landing.visual.privacy": "Privacy Policy",
    "landing.visual.terms": "Terms of Service",
    "landing.visual.dpa": "Data Processing",
    "err.name": "Use a display name with at least 2 characters.",
    "err.email": "Use a valid email.",
    "err.password.min": "At least 8 characters.",
    "err.exists": "This email is already registered. Sign in to your account.",
    "err.register": "Your account could not be created. Try again.",
    "err.registerPartial": "Your account was created, but setup is incomplete. Sign in to continue email verification.",
    "err.credentials": "Email or password does not match.",
    "verify.title": "Check your email",
    "verify.body": "Open the verification link in the email for {email}, then sign in again to continue. Check your spam folder too. If the link has not arrived, resend it after the countdown ends.",
    "verify.bodyAnon": "Open the verification link in your email, then sign in again to continue. Check your spam folder too. To resend the link, sign in first.",
    "verify.resend": "Resend link",
    "verify.signinAction": "Sign in again",
    "verify.resent": "Verification link resent. Check your inbox and spam folder.",
    "verify.failed": "The verification link could not be sent. Try again.",
    "verify.signinRequired": "Sign in before resending the verification link.",
    "verify.alreadyVerified": "Your email is already verified. Sign in to continue.",
    "verify.wait": "Wait until the countdown ends before resending.",
    "consent.title": "Consent",
    "consent.data.title": "Account data",
    "consent.data.desc": "Allow storage of your account data and decisions. This consent is required to use the workspace.",
    "consent.data.required": "Required",
    "consent.ai.title": "AI processing",
    "consent.ai.desc": "Optional. Allow AI to process notes and compose decision briefs. When off, the model is not called and you can still record decisions manually.",
    "consent.analytics.title": "Analytics",
    "consent.analytics.desc": "Optional. Allow usage activity to be recorded without including decision text, items, or the reason for your decision.",
    "consent.on": "On",
    "consent.off": "Off",
    "consent.continue": "Save and continue",
    "consent.busy": "Saving consent...",
    "consent.fail": "Consent was not recorded. Try again.",
    "consent.policy": "Read policies and terms",
    "policy.title": "Policy draft",
    "filter.all": "All",
    "status.draft": "Draft",
    "status.composing": "Composing",
    "status.ready": "Ready for review",
    "status.committed": "Recorded",
    "status.deferred": "Deferred",
    "mem.search": "Search decisions by title or status",
    "decisions.workspace": "Decision workspace",
    "decisions.lede": "Find your decisions by title or status, then open one to see its context.",
    "decisions.horizon": "Horizon: {n} days",
    "decisions.count": "{count} decisions",
    "decisions.open": "Open decision",
    "mem.searchPh": "Search title or status",
    "mem.filters": "Decision status filter",
    "mem.empty": "No decisions yet. Begin with the question in front of you.",
    "mem.emptyFilter": "No decisions match this search and filter. Change your search or select All statuses.",
    "horizon.days": "{n} days",
    "intake.step.question": "Question",
    "intake.step.notes": "Notes",
    "intake.step.items": "Items",
    "intake.step.options": "Options",
    "intake.stepSr": "Step {n}: {name}",
    "intake.back": "Back",
    "intake.example": "See an example",
    "intake.next": "Continue",
    "intake.saving": "Saving draft...",
    "field.title": "Title",
    "field.question": "Question",
    "field.outcome": "Desired outcome",
    "field.horizon": "Decision horizon",
    "intake.horizonHint": "The time span for considering a decision's impact, not the date by which you must choose.",
    "question.hint": "Write the question to be answered, not a task.",
    "err.title": "Use a title with at least 3 characters.",
    "err.question": "Write a decision question with at least 12 characters.",
    "err.item": "Item is too short.",
    "err.optName": "Option name is required.",
    "err.saveDraft": "Draft was not saved. Try again.",
    "err.saveNote": "Notes were not saved. Try again.",
    "err.saveItem": "Item was not saved. Try again.",
    "err.saveOption": "Option was not saved. Try again.",
    "err.parse": "Notes were not parsed. Try again.",
    "err.compose": "Decision Brief was not composed. Try again.",
    "notes.label": "Notes",
    "notes.cut": "The 2,000-character limit has been reached.",
    "notes.parse": "Parse notes",
    "notes.parsing": "Parsing notes...",
    "notes.toItems": "Continue to items",
    "notes.saving": "Saving notes...",
    "ai.badge": "AI INFERENCE",
    "ai.noConsent": "AI processing is not approved. Decisions can still be recorded manually.",
    "ai.quotaOut": "Four calls this cycle have been used. You can still record your decision.",
    "ai.preview": "Review suggestions before adding them as items.",
    "ai.proposals": "Suggested items",
    "ai.quota": "{n} of 4 left",
    "items.suggested": "suggested",
    "items.accept": "Accept",
    "items.edit": "Edit",
    "items.discard": "Discard",
    "items.changeStatus": "Change status",
    "items.editTitle": "Edit item",
    "items.save": "Save",
    "items.close": "Close",
    "items.addLabel": "Add item",
    "items.add": "Add",
    "items.status": "Status",
    "items.hint": "Add at least one Known or Assumed item.",
    "opt.name": "Option name",
    "opt.desc": "Description",
    "opt.rev": "Reversibility",
    "opt.add": "Add option",
    "opt.list": "Options",
    "opt.min": "At least two options before the brief.",
    "rev.easy": "Easy",
    "rev.costly": "Costly",
    "rev.hard": "Hard",
    "brief.compose": "Compose Decision Brief",
    "brief.composing": "Composing the Decision Brief...",
    "brief.skip": "Continue without brief",
    "dirty.title": "Changes are not saved.",
    "dirty.stay": "Stay here",
    "dirty.discard": "Discard",
    "contoh.title": "Example",
    "example.badge": "EXAMPLE",
    "example.back": "Back to decision entry",
    "example.note": "An illustrative example, not your account data. AI inference and the user's choice are shown separately; this page does not save decisions.",
    "example.briefNote": "An example brief, not a result generated for your account.",
    "layer.facts": "Your facts",
    "layer.decision": "Your decision",
    "rationale": "Decision rationale",
    "commit.differ": "Your choice differs from the Recommendation. Your rationale is what is recorded.",
    "brief.title": "Decision Brief",
    "brief.reviewNote": "Review the recommendation before recording your decision.",
    "brief.toc": "Decision Brief contents",
    "brief.framework": "Framework",
    "brief.assumptions": "Assumptions",
    "brief.unknowns": "Unknowns",
    "brief.tradeoffs": "Trade-offs",
    "brief.recommendation": "Recommendation",
    "brief.change": "Conditions for reconsideration",
    "brief.confidence": "AI confidence",
    "refchip.aria": "Item {id}, open original text",
    "item.source": "Source",
    "item.itemTitle": "Item {id}",
    "ws.all": "All decisions",
    "ws.pin": "Pin to Attention",
    "ws.unpin": "Unpin from Attention",
    "ws.commit": "Record decision",
    "ws.delete": "Delete",
    "ws.facts": "Your facts",
    "ws.brief": "Decision Brief",
    "ws.relatedChapters": "Related chapters",
    "ws.compose": "Compose Decision Brief",
    "ws.challenge": "Challenge my thinking",
    "ws.missing": "What am I missing?",
    "ws.makeItem": "Make item",
    "ws.continuity": "Check continuity",
    "ws.nextAction": "Next action",
    "ws.review": "Review date",
    "ws.commitDate": "Recorded on",
    "ws.deferred": "Deferred",
    "err.pinMax": "You can pin up to 3 decisions to Attention. Unpin one before adding another.",
    "err.pin": "Pin was not saved. Try again.",
    "err.challenge": "Attachment was not composed. Try again.",
    "err.continuity": "The check did not complete. Try again.",
    "err.deleteOption": "Option was not deleted. Try again.",
    "err.load": "Unable to load. Try again.",
    "brief.abstain": "Not enough context for a brief. Add a Known or Assumed item, then try again.",
    "ai.kill": "AI composing is paused. Decisions and notes can still be read.",
    "locked": "Library and Decision Brief are paused. Your notes remain saved.",
    "ws.notFound": "Decision not found.",
    "commit.title": "Your decision",
    "commit.recLabel": "Recommendation",
    "commit.defer": "Defer",
    "commit.choosePlaceholder": "Choose a decision option",
    "commit.rationale": "Decision rationale",
    "commit.hint": "Write your own reason using at least 20 characters.",
    "commit.reviewHint": "The date to revisit the decision after it is recorded, not the date by which you must choose.",
    "commit.nextAction": "Next action",
    "commit.reviewDate": "Review date",
    "commit.submit": "Record decision",
    "commit.busy": "Recording decision...",
    "commit.ok": "Decision recorded. Next action and review date are saved.",
    "commit.fail": "Decision was not recorded. Try again.",
    "err.rationale": "Write a decision rationale with at least 20 characters.",
    "att.review": "Review within 7 days",
    "att.unknown": "Unresolved unknowns",
    "lib.title": "Reading",
    "lib.archive": "Library / Selected reading",
    "lib.collectionLede": "Explore selected reading to deepen your thinking. Save important ideas in your notes and return to them when you need them.",
    "lib.collection": "Reading collection",
    "lib.bookCount": "Books: {n}",
    "lib.lede": "Original AXORIS texts. Not a store.",
    "lib.empty": "No books have been published yet.",
    "lib.continue": "Continue reading",
    "lib.lastRead": "Last read",
    "lib.failLoad": "The reading collection could not be loaded. Try again.",
    "lib.estimatedMinutes": "About {n} min read",
    "lib.minutes": "{n} min",
    "lib.notesLink": "My notes",
    "lib.locked": "Library access is paused. Your notes remain saved.",
    "lib.lockedCard": "Locked",
    "book.read": "Continue reading",
    "book.start": "Start reading",
    "book.restore": "Manage access",
    "book.notFound": "This book could not be found.",
    "book.failLoad": "Book details could not be loaded. Try again.",
    "book.chapters": "Contents",
    "book.chapterCount": "Chapters: {n}",
    "book.empty": "No chapters are available yet.",
    "book.back": "Back to Library",
    "reader.toc": "Contents",
    "reader.size": "Text size",
    "reader.theme": "Reader theme",
    "reader.bookmark": "Bookmark",
    "reader.back": "Back to book details",
    "reader.sizeValue": "Text size {n} pixels",
    "reader.toLight": "Use light reading theme",
    "reader.toDark": "Use dark reading theme",
    "reader.addBookmark": "Bookmark this chapter",
    "reader.removeBookmark": "Remove this chapter bookmark",
    "reader.bookmarkFail": "Bookmark not saved. Try again.",
    "reader.progressFail": "Reading position not saved. Check your connection.",
    "reader.prev": "Previous chapter",
    "reader.next": "Next chapter",
    "reader.empty": "This chapter has no content yet.",
    "chapter.fail": "This chapter could not be loaded.",
    "chapter.notFound": "This chapter could not be found.",
    "highlight.invalid": "Select a quote of no more than 280 characters.",
    "highlight.title": "Highlight",
    "highlight.color": "Color",
    "highlight.teal": "Teal",
    "highlight.gold": "Gold",
    "highlight.remark": "Note (optional)",
    "highlight.remarkHint": "No more than 280 characters.",
    "highlight.save": "Save highlight",
    "err.saveHighlight": "Highlight was not saved. Try again.",
    "notes.title": "My notes",
    "notes.collectionLede": "Revisit quotes and notes from your reading. Add relevant quotes as items to a decision.",
    "notes.count": "Highlights: {n}",
    "notes.empty": "No highlights yet. Select a quote while reading a book to save it here.",
    "notes.remarkLabel": "Your note",
    "notes.open": "Open chapter",
    "notes.journal": "Add to decision",
    "journal.saved": "The quote was added as an ASSUMED item. Review its status in your decision.",
    "journal.pick": "Choose the destination decision",
    "journal.hint": "The quote is added as an ASSUMED item, rather than a confirmed fact. Your personal note stays in Library. The active Decision Brief will need to be composed again.",
    "journal.create": "Create decision draft",
    "journal.done": "Already added to a decision",
    "acc.workspaceTitle": "Account settings",
    "acc.lede": "Manage your display preferences, access, privacy, and account security.",
    "acc.prefs": "Display preferences",
    "acc.cadenceFailed": "Email preference was not saved. Try again.",
    "acc.lang": "Language",
    "acc.theme": "Theme",
    "theme.light": "Light",
    "theme.dark": "Dark",
    "theme.system": "System",
    "acc.cadence": "Email only when something material changes.",
    "acc.sub": "Subscription",
    "acc.accountType": "Account type",
    "acc.period": "Period",
    "acc.trialUntil": "Trial until",
    "acc.pilotPermanent": "Pilot accounts stay active without a time limit.",
    "acc.accessLoading": "Loading account access…",
    "acc.accessUnavailable": "Account access could not be loaded.",
    "acc.accessExpired": "Access ended",
    "acc.accessPastDue": "Access locked",
    "acc.accessNone": "Not active",
    "acc.retry": "Try again",
    "acc.photoChange": "Change photo",
    "acc.photoLoading": "Loading photo…",
    "acc.photoSave": "Save photo",
    "acc.photoCancel": "Cancel",
    "acc.photoReadFailed": "Photo could not be loaded.",
    "acc.photoWriteFailed": "Photo was not saved. Try again.",
    "acc.photoInvalid": "Choose JPEG, PNG, or WebP, up to 2 MB.",
    "mfa.title": "Two-factor authentication",
    "mfa.active": "Active. An authenticator is enrolled.",
    "mfa.inactive": "Not active.",
    "mfa.optionalNote": "2FA is optional. Before enabling it, you can sign in as usual. Once enabled, an authenticator code is required to sign in.",
    "mfa.enable": "Enable 2FA",
    "mfa.disable": "Disable authenticator",
    "mfa.addBackup": "Add backup authenticator",
    "mfa.authenticator": "Authenticator",
    "mfa.backupNote": "Back up your authenticator according to its app instructions.",
    "mfa.factorLimit": "An authenticator is already enrolled. Disable the existing factor before replacing it.",
    "mfa.localUnavailable": "TOTP enrollment is unavailable in the local emulator. Live testing requires Firebase with Identity Platform.",
    "mfa.unavailable": "Two-factor authentication is unavailable. Try again later or contact account support.",
    "mfa.actionFailed": "Verification failed. Try again or sign in again.",
    "mfa.codeFailed": "Verification was unsuccessful. Use the latest code from your authenticator app and try again.",
    "mfa.code": "6-digit code",
    "mfa.verify": "Verify code",
    "mfa.challengeNote": "Enter the six-digit code from your authenticator app to continue.",
    "mfa.unsupported": "This account's verification method is not supported here. Contact account support.",
    "mfa.currentPassword": "Current password",
    "mfa.continue": "Verify identity",
    "mfa.googleReauth": "Verify with Google",
    "mfa.reauthNote": "Verify your identity before adding an authenticator.",
    "mfa.removeNote": "Verify your identity to remove this factor.",
    "mfa.scanNote": "Scan this QR with your authenticator app, then enter the displayed code.",
    "mfa.qrAlt": "QR to add AXORIS to an authenticator",
    "mfa.manualKey": "Or enter this key manually:",
    "mfa.enabled": "Authenticator was added.",
    "mfa.removed": "The authenticator was disabled.",
    "mfa.expired": "Setup expired. Start again to get a new key.",
    "mfa.loginExpired": "The verification session is no longer valid. Select Cancel, then sign in again to start a new session.",
    "mfa.passwordReauth": "Verify your identity again before saving the new password.",
    "sub.price": "Price",
    "sub.method": "Method",
    "sub.date.trialing": "First charge",
    "sub.date.active": "Renewal",
    "sub.date.canceled": "Access until",
    "sub.date.past_due": "Due",
    "sub.date.expired": "Ended",
    "sub.none": "No subscription yet.",
    "sub.pilotNotice": "Pilot access via invitation.",
    "acc.accessPilot": "Pilot",
    "acc.accessTrial": "Trial",
    "acc.accessPremium": "Premium",
    "sub.contactSupport": "Contact support",
    "sub.trialNotice": "Public accounts have a seven-day trial from account creation. There is no automatic billing.",
    "sub.premiumNotice": "Your account has Premium access.",
    "sub.expiredNotice": "Your access period has ended. Your notes remain saved. Payments are not available yet.",
    "sub.unavailableNotice": "Your account access is not active. Your notes remain saved. Contact support if you need help.",
    "sub.accessUntil": "Access until",
    "sub.start": "Start subscription",
    "sub.cancel": "Cancel subscription",
    "sub.cancelBody": "Access continues until the end of the period already paid.",
    "sub.keep": "Keep",
    "err.cancel": "Subscription was not canceled. Try again.",
    "acc.privacy": "Privacy and data",
    "acc.exportTitle": "Account data archive (JSON)",
    "acc.export": "Export JSON",
    "acc.exporting": "Exporting...",
    "acc.exportFail": "Failed to export account data. Please try again later.",
    "acc.exportNote": "Decisions, highlights, and consent. No analytics.",
    "acc.delete": "Delete account",
    "acc.deleting": "Deleting...",
    "acc.deleteBody": "Your account and its decisions, sheets, highlights, consent records, and profile photo will be permanently deleted. This cannot be undone.",
    "acc.deleteField": "Type HAPUS",
    "acc.deleteHint": "Type HAPUS exactly as shown to continue.",
    "err.delete": "Failed to delete account. Try again.",
    "acc.security": "Account security",
    "acc.passwordHint": "Use 8–72 characters.",
    "acc.keepAccount": "Keep my account",
    "acc.status": "Status",
    "acc.pwFailed": "Password was not updated. Try again or sign in again.",
    "acc.newPw": "New password",
    "acc.pwSave": "Change password",
    "acc.pwSaved": "Password updated.",
    "acc.signout": "Sign out",
    "acc.signingOut": "Signing out...",
    "acc.totp": "TOTP",
    "acc.totpNote": "Not required on this plan.",
    "acc.totpPreview": "Preview preference only; does not enable two-factor authentication.",
    "plan.title": "Subscription",
    "plan.priceHint": "Compare monthly and annual prices. Selecting a period does not activate a subscription.",
    "plan.resultNote": "This status comes from your account data and is not a payment confirmation.",
    "plan.seg": "Subscription period",
    "plan.monthly": "Monthly",
    "plan.annual": "Annual",
    "plan.perMonth": "/ month",
    "plan.perYear": "/ year",
    "plan.eq": "equivalent to {price} / month",
    "plan.save": "Save {price}",
    "plan.trial": "Public accounts have a seven-day trial from account creation. Pilot accounts remain active indefinitely.",
    "plan.availability": "Payment availability",
    "plan.paymentNotice": "Payments are not available yet.",
    "plan.paymentUnavailable": "Payments unavailable",
    "plan.noBilling": "There is currently no billing date or automatic billing.",
    "plan.loading": "Loading subscription prices…",
    "plan.pricesUnavailable": "Subscription prices could not be loaded. Try again.",
    "plan.accessTitle": "Your access status",
    "plan.unconfirmed": "Your access status could not be confirmed. Try again or check Account.",
    "plan.toAccount": "Open Account",
    "trial.h2": "Your trial ends on {date}. There is no automatic billing.",
    "banner.manage": "Manage",
    "nav.sheet": "Sheets",
    "sheet.title": "Sheet",
    "sheet.listWorkspace": "Executive workspace",
    "sheet.listEyebrow": "Notes & considerations",
    "sheet.listLede": "A space for goals, journals, and considerations before they become decisions.",
    "sheet.listCount": "{count} notes",
    "sheet.listOpen": "Open sheet",
    "sheet.listEmptyHint": "Start with a goal, a journal, or a note you want to examine.",
    "sheet.lede": "Write what is not a decision yet.",
    "sheet.empty": "No sheets yet.",
    "sheet.new": "New sheet",
    "sheet.save": "Save",
    "sheet.saveAdd": "Save addition",
    "sheet.saved": "Saved.",
    "sheet.body": "Your note",
    "sheet.classification": "Sheet type",
    "sheet.draft": "Draft",
    "sheet.status.open": "Note",
    "sheet.characters": "{count} characters",
    "sheet.synthesis": "Note reading",
    "sheet.hint": "A goal, journal, target, objective, or anything not yet a decision.",
    "sheet.read": "Ask for a reading",
    "sheet.reading": "Preparing the note reading…",
    "sheet.add": "Add a note",
    "sheet.addLabel": "Your addition",
    "sheet.promote": "Create decision draft",
    "sheet.promoteCta": "Create draft",
    "sheet.promoted": "Decision draft created. This sheet remains saved.",
    "sheet.promoteNote": "The question and title below become a decision draft. You will need to add items and options. The sheet remains saved.",
    "sheet.cancel": "Cancel",
    "sheet.quota": "The reading limit has been reached. You can still save notes. A decision draft can be created from questions already available.",
    "sheet.aiOff": "AI readings are not authorized. You can still save notes. Manage AI consent in privacy settings.",
    "sheet.abstain": "This note does not yet provide enough context for a reading and decision questions. Add relevant context.",
    "sheet.failSave": "The sheet was not saved. Try again.",
    "sheet.failRead": "The reading is not available. Try again.",
    "sheet.failLoad": "The sheet could not be loaded.",
    "sheet.searchEmpty": "No sheets match your search in this filter. Change your search or choose another filter.",
    "sheet.filterEmpty": "No sheets in this filter yet. Choose another filter to view your sheets.",
    "sheet.searchPh": "Search title or content preview",
    "sheet.filters": "Sheet filters",
    "sheet.kind": "Kind",
    "sheet.titleLabel": "Title (optional)",
    "sheet.titlePh": "Optional sheet title",
    "sheet.date": "Note date",
    "sheet.menu": "Sheet actions",
    "sheet.park": "Park",
    "sheet.archive": "Archive",
    "sheet.delete": "Delete this sheet? A decision created from it will remain.",
    "sheet.deleteCta": "Delete",
    "sheet.keep": "Keep this sheet",
    "sheet.question": "Question",
    "sheet.draftTitle": "Draft title",
    "sheet.sumHead": "Summary",
    "sheet.seenHead": "What is visible",
    "sheet.unclearHead": "What is not clear",
    "sheet.raiseHead": "Questions for a decision draft",
    "sheet.limit": "The limit of three notes per sheet has been reached. Start a new sheet for a different topic.",
    "sheet.errVersion": "The sheet changed elsewhere. Reload it.",
    "sheet.errClosed": "This note has been read. Add a new note.",
    "sheet.errDisabled": "AXORIS readings are currently unavailable.",
    "sheet.errNoread": "Add a note before the next reading.",
    "sheet.errText": "The note must contain 20–6,000 characters.",
    "sheet.errAdd": "The addition must contain 20–2,000 characters.",
    "sheet.errTitleMax": "The title must be no longer than 80 characters.",
    "sheet.errDate": "The date is not valid.",
    "sheet.status.parked": "Parked",
    "sheet.status.promoted": "Promoted",
    "sheet.status.archived": "Archived",
    "kind.free": "Open",
    "kind.goal": "Goal",
    "kind.target": "Target",
    "kind.objective": "Objective",
    "kind.journal": "Journal",
    "open": "Open",
  },
};
